export default __webpack_public_path__ + "static/media/logo.b0e70c5e.svg";